import { DataService } from "@/services/data";
import { handle_error } from "@/utils/wretch";
import { json, RouteObject } from "react-router-dom";

const TaskRoute: RouteObject = {
    path: "tasks",
    loader: ({ request }) => {
        const url = new URL(request.url);
        if (!url.searchParams.has("page_size")) {
            url.searchParams.set("page_size", "5");
        }
        const tasks = DataService.client
            .url(`/medrep/tasks/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
            .get()
            .json();
        return tasks;
    },
    action: async ({ request }) => {
        const data = await request.json();

        try {
            const content = await DataService.client.url(`/medrep/tasks/`).post(data).json();
            return json({ success: true, content: content });
        } catch (error) {
            return handle_error(error);
        }
    },
    children: [
        {
            path: ":taskId",
            action: async ({ params, request }) => {
                const taskId = params.taskId;
                const data = await request.json();
                try {
                    let content;
                    if (request.method == "POST") {
                        content = await DataService.client.url(`/medrep/tasks/${taskId}/`).patch(data).json();
                    } else if (request.method == "DELETE") {
                        content = await DataService.client.url(`/medrep/tasks/${taskId}/`).delete().json();
                    }
                    return json({ success: true, content: content });
                } catch (error) {
                    return handle_error(error);
                }
            }
        }
    ]
};

export default TaskRoute;
